
import React from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth-context";
import { Github, Mail } from "lucide-react";

interface SocialSignInProps {
  isLoading?: boolean;
}

const SocialSignIn: React.FC<SocialSignInProps> = ({ isLoading = false }) => {
  const { signInWithProvider } = useAuth();

  const handleGoogleSignIn = () => {
    signInWithProvider('google');
  };

  const handleGithubSignIn = () => {
    signInWithProvider('github');
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      <Button
        variant="outline"
        type="button"
        onClick={handleGoogleSignIn}
        disabled={isLoading}
        className="flex items-center justify-center gap-2"
      >
        <Mail className="h-4 w-4 text-red-500" />
        Google
      </Button>
      <Button
        variant="outline"
        type="button"
        onClick={handleGithubSignIn}
        disabled={isLoading}
        className="flex items-center justify-center gap-2"
      >
        <Github className="h-4 w-4" />
        GitHub
      </Button>
    </div>
  );
};

export default SocialSignIn;
